var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinpointFc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "101px",
    viewBox: "0 0 74 101",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "svgs/pinpoint-fc") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgs/pinpoint-fc",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(2, 2.6667)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#41005E",
    cx: 35,
    cy: 90.4761905,
    rx: 20.3225806,
    ry: 4.52380952
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.391,2.60213189 C54.77269,5.18439576 60.2383362,9.57664601 64.099,15.22524 C67.934048,20.8230986 69.9890142,27.4265489 70,34.1875834 C70,43.2535217 67.081,48.4439445 59.745,58.3611127 L35,90.4761905 L10.255,58.3818709 C2.919,48.4439445 0,43.2742829 0,34.2083446 C0.0067990783,27.4402323 2.06194807,20.8289603 5.901,15.22524 C9.7647536,9.58433601 15.2300862,5.1995622 21.609,2.62289371 C25.8581519,0.897560199 30.406446,0.00668656942 35,0 C39.5921652,0 44.1404089,0.883909277 48.391,2.60213189 Z",
    id: "Vector-14-path-Copy-3",
    fill: "#00D988"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinpointFc);
export default __webpack_public_path__ + "static/media/pinpoint-fc.ae8160570b2b9152496b1ef0f1ebd7c1.svg";
export { ForwardRef as ReactComponent };